import React from 'react'
import { makeStyles, useMediaQuery } from '@material-ui/core'
import ImageSection from './ImageSection'
import TextSection from './TextSection'


const useStyles = makeStyles({
  root: {
    boxSizing: 'border-box',
    padding: 16,
    display: 'flex',
    alignItems: 'center'
  }
})

export default function CallToAction(props){

  const classes = useStyles()

  const isMobile = useMediaQuery('(max-width: 768px)')

  const { app, scrollToUploadSection } = props
  return (
    <div className={[classes.root, 'callToActionRoot'].join(' ')}>
      <div className={'textSection'}>
        <TextSection
          isMobile={isMobile} 
          description={app.description} 
          scrollToUploadSection={scrollToUploadSection}/>
      </div>
      <div className={'imageSection'}>
        <ImageSection image={app.image}/>
      </div>
    </div>
  )
}